import ProjectReportDataOption from "../ProjectReportDataOption";

describe("ProjectReportDataOption model", () => {
  test("belongsTo relations", () => {
    expect(
      ProjectReportDataOption.belongsTo.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
